import type {
  PSDGeneral,
  PSDPreparation,
  HydrometerType,
  DispersionMethod,
} from '../../../types/psd';

export const preparationOptions: { value: PSDPreparation; label: string }[] = [
  { value: 'AsReceived', label: 'As received' },
  { value: 'AirDry', label: 'Air dry' },
  { value: 'OvenDry', label: 'Oven dry' },
];

export const hydrometerTypeOptions: { value: HydrometerType; label: string }[] = [
  { value: '152H', label: '152H' },
  { value: '151H', label: '151H' },
];

export const dispersionMethodOptions: { value: DispersionMethod; label: string }[] = [
  { value: 'Stirrer', label: 'Stirrer' },
  { value: 'AirJet', label: 'Air jet' },
  { value: 'Other', label: 'Other' },
];

export const EMPTY_PSD_GENERAL: PSDGeneral = {
  sieveTestMethod: 'ASTM D6913-04(2009)',
  preparation: null,
  specimenTakenFrom: null,
  ovenTemperatureC: 110,
  ovenNumber: null,
  washingPerformed: false,
  washingNotes: null,
  massOfContainer: null,
  massOfWetSoilAndContainer: null,
  massOfDrySoilAndContainer: null,

  panId: null,
  massOfPan: null,
  totalMassWetSampleAndPan: null,
  totalMassAirOvenDrySampleAndPan: null,
  waterContentPercent: null,
  depthOverride: null,

  sieveNestKey: null,
  designated1stSeparationSieveMm: null,
  designated2ndSeparationSieveMm: null,

  pre1stSepDryMassRetained: null,
  pre1stSepMassBelowDry: null,
  subSamplePanId: null,
  massOfSubsamplePan: null,
  airOvenDrySubsamplePlusPan: null,
  massOfSubsampleBelow1st: null,
  washedDryAndContainerMass1st: null,
  dryMassPassing1st: null,
  dryMassOfSubsampleBelow1st: null,

  pre2ndSepDryMassRetained: null,
  pre2ndSepDryMassPassing: null,
  dryMassOfSubsampleBelow2nd: null,
  dryMassAbove75umAfterWashing: null,
  washedDryAndContainerMass2nd: null,
  ifWholeSampleWashedMassAbove75um: null,

  hydrometerEnabled: false,
  hydroTestMethod: 'ASTM D7928',
  hygroscopicMassWetSoilAndContainer: null,
  gsAssumed: true,
  gsValue: 2.65,
  compositeCorrectionSlope: null,
  compositeCorrectionIntercept: null,
  calibrationConstantJ1: null,
  calibrationConstantJ2: null,
  hydrometerNumber: null,
  hydrometerType: '152H',
  methodOfDispersion: 'Stirrer',
  methodOfDispersionOther: null,
  dispersingAgentUsed: 'Sodium hexametaphosphate',
  volumeOfDispersantMl: 125,
  dispersionTimeMin: 1,
  initialMassOfSpecimenBelow2mm: null,
  totalDryMassRepresentedInHydroW: null,
  hydroRemarks: null,

  overrideLL: null,
  overridePL: null,
  overridePI: null,
  overrideUSCSDescription: null,
  comments: null,
  additionalObservations: null,

  computedD60: null,
  computedD30: null,
  computedD10: null,
  computedCu: null,
  computedCc: null,
  computedCoarserThanGravelPercent: null,
  computedGravelPercent: null,
  computedSandPercent: null,
  computedFinesPercent: null,
  computedSiltPercent: null,
  computedClayPercent: null,
  uscsDescription: null,
};
